import { IpInput, IpInputProps, FormContext, FormInputGroupLayoutContext } from "o4a-react";
import React from "react";
import { mergeStyleSets } from "@fluentui/react";
import { AddressRange } from "../AddressRange/AddressRange";
import * as Messages from "../../codegen/Messages";

const classNames = mergeStyleSets({
  range: {
    width: "55%",
    minWidth: "107px",
    "*": { textOverflow: "unset" },
  },
  address: {
    width: "45%",
    minWidth: "107px",
    marginRight: "10px",
    "*": { textOverflow: "unset !important" },
  },
});

/**
 * DO NO EXPOSE
 * You are on your own if you want to use this computed value
 */
const enum Fields {
  AddressRangeDisplay = "AddressRangeDisplay"
}

export type NetworkAddressInputProps = IpInputProps

/**
 * The address range can be located by combining the exported field name with  the passed field name
 * ex Fields.AddressRangeDisplay + fieldName
 */
export const NetworkAddressInput = ({
  defaultValue,
  fieldName,
  groupName,
  onChange,
  label,
  ...ipInputProps
}: NetworkAddressInputProps): JSX.Element => {
  const form = React.useContext(FormContext);

  if (!form) throw new Error("NetworkAddressInput must be used within Form");

  const { groupName: layoutGroup } = React.useContext(
    FormInputGroupLayoutContext,
  );
  const group = groupName || layoutGroup;

  // Handles retriving the previous value that the form remembers
  const initialValue = form.getValue(fieldName, group) ?? defaultValue;

  const [address, setAddress] = React.useState(initialValue);

  const internalOnChange = (value: string): void => {
    setAddress(value);
    onChange?.(value);
  };

  return (
    <>
      <IpInput
        {...ipInputProps}
        label={label}
        defaultValue={initialValue}
        fieldName={fieldName}
        groupName={groupName}
        onChange={internalOnChange}
        className={classNames.address}
      />
      <AddressRange
        defaultValue={address}
        // Need to make it as a prefix
        // This is for compatibility with simple builder
        // As otherwise the getValuesByFieldPrefix would return this as well
        fieldName={Fields.AddressRangeDisplay + fieldName}
        groupName={groupName}
        label={label ? Messages.labels.addresses() : undefined}
        className={classNames.range}
      />
    </>
  );
};
